module.exports = __webpack_public_path__ + "static/20180910_140045-29d5b2997772ed56b70f660857f4dd8b.jpg";